import { Installation } from "../Installation";
import { MachineStatus } from "../status/MachineStatus";
import { AgentInfo } from "../agent/AgentInfo";
import { MachineContent } from "../content/MachineContent";
import { CashCount } from "../CashCount";

export class InstallationSummary extends Installation {
    /** Lista di machine status, informazioni specifiche sullo stato di ogni macchina */
    statusMachines: MachineStatus[] = [];

    /** Informazioni sull'agent */
    agentInfo: AgentInfo = null;

    /** Lista di machine content, informazioni specifiche sul contenuto di ogni macchina */
    contentMachines: MachineContent[] = [];

    /** Installation content  */
    content: CashCount = null;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.StatusMachines && obj.StatusMachines.length > 0) {
            obj.StatusMachines.forEach((e) => {
                var ms: MachineStatus = new MachineStatus();
                ms.parse(e);
                this.statusMachines.push(ms);
            });
        }

        if (obj.AgentInfo) {
            this.agentInfo = new AgentInfo();
            this.agentInfo.parse(obj.AgentInfo);
        }

        if (obj.ContentMachines && obj.ContentMachines.length > 0) {
            obj.ContentMachines.forEach((e) => {
                var ms: MachineContent = new MachineContent();
                ms.parse(e);
                this.contentMachines.push(ms);
            });
        }

        if (obj.Content) {
            this.content = new CashCount();
            this.content.parse(obj.Content);
        }
    }
}
